import { render, staticRenderFns } from "./ProductRangeDialogue.vue?vue&type=template&id=2e3a8a06&"
import script from "./ProductRangeDialogue.vue?vue&type=script&lang=ts&"
export * from "./ProductRangeDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports